import * as API from '@siloreal:shared:api';

const SILOBAG_ARCHIVED_LIST_ENDPOINT = '/silobags/archive';

export type SilobagArchivedListQueryValue = string | number | boolean | undefined | null;

export type SilobagArchivedListQuery = Partial<{
  organization_id: SilobagArchivedListQueryValue;
}>;

export type SilobagArchivedListServiceContract = {
  query?: SilobagArchivedListQuery;
  signal?: AbortSignal;
};

export async function listArchivedSilobagsService(
  contract: SilobagArchivedListServiceContract = {}
): Promise<SilobagArchivedListResponse> {
  const { data } = await API.http.fetch.get<SilobagArchivedListResponse>(SILOBAG_ARCHIVED_LIST_ENDPOINT, {
    query: buildSilobagArchivedListQuery(contract.query),
    signal: contract.signal,
  });

  return data;
}

export function buildSilobagArchivedListQuery(query?: SilobagArchivedListQuery): string {
  const queryParameters = new URLSearchParams();

  Object.entries(query ?? {}).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    if (typeof value === 'string' && value.trim().length === 0) return;

    queryParameters.set(key, String(value).trim());
  });

  const serializedQuery = queryParameters.toString();

  return serializedQuery ? `?${serializedQuery}` : '';
}

export type SilobagArchivedListResponse = {
  data: SilobagArchivedListItem[];
  web_silobags: number;
  totalFilteredSilobags: number;
  filteredInputWeight: string;
  filteredExtractedWeight: number;
  totalInputWeight: string;
  totalExtractedWeight: number;
  page: number;
  pageSize: number;
  rowCount: number;
};

export type SilobagArchivedListItem = {
  id: string;
  silobag_name: string;
  created_at: string;
  bagging_date: string | null;
  initial_humidity: number | null;
  input_weight: string;
  organization_id: number;
  organization_name: string;
  countryside_id: number;
  countryside_name: string;
  silobag_harvest_id: number | null;
  silobag_harvest_name: string | null;
  silobag_product_type_id: number;
  silobag_product_type_name: string;
  silobag_species_type_id: number;
  silobag_species_type_name: string;
  language_id: number;
  write_permission: boolean;
};
